/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForPrivateCloud extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForPrivateCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForPrivateCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForPrivateCloud>): ServiceAccountCredentialsForPrivateCloud {
        let obj = Object.assign(new ServiceAccountCredentialsForPrivateCloud(), model);
        ServiceAccountCredentialsForPrivateCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForPrivateCloud>): ServiceAccountCredentialsForPrivateCloud {
        if (!model) return null;
        return ServiceAccountCredentialsForPrivateCloud.newInstance(<ServiceAccountCredentialsForPrivateCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForPrivateCloud) {
        if (!obj) return;

        models.ServiceAccountCredentialsForPrivateCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForPrivateCloud): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForPrivateCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
